Ext.define('WindowAbout', {
    extend: 'Ext.ux.window.WindowExd',
    width: 370,
    height: 288,
    frame: false,
    border: false,
    header: false,
    closable: false,
    plain: true,
    style: "background-color: transparent; border-style: none;",
    shadow: false,
    collapsible: false,
    modal: true,
    resizable: false,
    constrain: false,
    constrainHeader: false,
    layout: 'fit',
    initComponent: function () {
        this.cid = Ext.id();
        var leftTxtDays = new Ext.XTemplate(Lang.pozostalo_n_dni).apply({
            n: AppLeftdays
        });
        var imageClass1 = "";
        var imageClass2 = "";

        if (Const.SKPFLAG) {
            imageClass1 = "about-image-skp";
            imageClass2 = "about-image-skp3";
        } else if (Const.OPTIMALFLAG) {
            imageClass1 = "about-image-optimal";
            imageClass2 = "about-image-optimal3";
        } else if (Const.ENTERPRISEFLAG) {
            imageClass1 = "about-image-enterprise";
            imageClass2 = "about-image-enterprise3";
        } else if (Const.BASICFLAG) {
            if (Const.CUSTOMMODFLAG == 'swimer' || Const.CUSTOMMODFLAG == 'external_sibuso') {
                imageClass1 = "about-image-swimer";
                imageClass2 = "about-image-swimer3";
            } else {
                imageClass1 = "about-image-basic";
                imageClass2 = "about-image-basic3";
            }
        } else if (Const.STARTERFLAG) {
            imageClass1 = "about-image-starter";
            imageClass2 = "about-image-starter3";
        } else if (Const.STANDARDFLAG) {
            imageClass1 = "about-image-standard";
            imageClass2 = "about-image-standard3";
        } else {
            imageClass1 = "about-image-pro";
            imageClass2 = "about-image-pro3";
        }
        this.items = [{
            xtype: 'panel',
            bodyStyle: 'background-color: #e4e4e4;border:0px',
            defaults: {
                bodyStyle: 'background-color: #e4e4e4;border:0px',
                style: 'background-color: #e4e4e4;border:0px'
            },
            items: [{
                xtype: 'box',
                border: false,
                frame: false,
                width: '100%',
                height: '80px',
                cls: true ? imageClass2 : imageClass1,
                html: [{
                    tag: "div",
                    style: "position:absolute;top:3px;left:15px;z-index:2;color:black;font: bold 11px arial, tahoma, verdana, sans-serif",
                    html: Lang.o_programie.capitalise()
                }, {
                    id: this.cid + "arccan",
                    tag: "div",
                    style: `position:absolute;top:${WindowExdMobileDEVICEV && Ext.getBody().getViewSize().width < 340 ? '55' : '63'}px;left:20px;z-index:2;color:#dc5b00;font: bold 9px arial, tahoma, verdana, sans-serif;cursor:pointer`,
                    html: "www.arccan.eu"
                }]
            }, {
                xtype: 'panel',
                items: [{
                    xtype: 'box',
                    html: 'Copyright &copy; ' + new Date().getFullYear(),
                    style: 'float: right; padding: 4px 20px 0 0; font: bold 12px arial, tahoma, verdana, sans-serif;'
                }]
            }, {
                xtype: 'panel',
                items: [{
                    layout: 'hbox',
                    itemId: 'productKey-panel',
                    hidden: true,
                    style: 'padding: 10px 0 0 70px;background-color: #e4e4e4;',
                    items: [{
                        html: Lang.klucz_produktu + ":",
                        bodyStyle: 'color:#dc5b00;font: bold 12px arial, tahoma, verdana, sans-serif;background-color: #e4e4e4;'
                    }, {
                        itemId: 'productKey-box',
                        width: '100%',
                        bodyStyle: 'font: bold 12px arial, tahoma, verdana, sans-serif; padding-left: 15px;background-color: #e4e4e4;'
                    }]
                }, {
                    layout: 'hbox',
                    itemId: 'maintenanceTo-panel',
                    hidden: true,
                    style: 'padding: 10px 0 0 70px;background-color: #e4e4e4;',
                    items: [{
                        html: Lang.wsparcie_do + ":",
                        bodyStyle: 'color:#dc5b00;font: bold 12px arial, tahoma, verdana, sans-serif;background-color: #e4e4e4;'
                    }, {
                        itemId: 'maintenanceTo-box',
                        width: '100%',
                        bodyStyle: 'font: bold 12px arial, tahoma, verdana, sans-serif; padding-left: 15px;background-color: #e4e4e4;'
                    }]
                }, {
                    xtype: 'box',
                    hidden: AppActivated,
                    html: AppActivated ? "" : Lang.ten_produkt_nie_jest_jeszcze_aktywowany,
                    style: 'padding: 10px 0 0 70px; color:#dc5b00;font: bold 12px arial, tahoma, verdana, sans-serif;'
                }, {
                    xtype: 'box',
                    hidden: AppActivated,
                    html: AppActivated ? "" : leftTxtDays,
                    style: 'padding: 10px 0 0 70px; color:#dc5b00;font: bold 12px arial, tahoma, verdana, sans-serif;'
                }, {
                    xtype: 'panel',
                    items: [{
                        xtype: 'box',
                        itemId: 'opiekun-panel',
                        hidden: true,
                        html: Lang.opiekun.toUpperCase(),
                        style: 'text-align: center; color: #dc5b00;font: bold 12px arial, tahoma, verdana, sans-serif;background-color: #e4e4e4; padding-top: 20px;'
                    }, {
                        xtype: 'box',
                        itemId: 'opiekun-box',
                        style: 'text-align: center; font: bold 12px arial, tahoma, verdana, sans-serif;background-color: #e4e4e4; padding-top: 5px;'
                    }]
                }, {
                    layout: 'hbox',
                    style: 'padding: 20px 0 0 70px;background-color: #e4e4e4;',
                    items: [{
                        html: Lang.wersja.capitalise() + ":",
                        bodyStyle: 'color:#dc5b00;font: bold 12px arial, tahoma, verdana, sans-serif;background-color: #e4e4e4;'
                    }, {
                        html: Const.VERSIONEND,
                        width: '100%',
                        bodyStyle: 'font: bold 12px arial, tahoma, verdana, sans-serif; padding-left: 15px;background-color: #e4e4e4;'
                    }]
                }, {
                    layout: 'hbox',
                    style: 'padding: 20px 0 0 70px;background-color: #e4e4e4;',
                    items: [{
                        html: Lang.wersja_gui.capitalise(),
                        bodyStyle: 'color:#dc5b00;font: bold 12px arial, tahoma, verdana, sans-serif;background-color: #e4e4e4;'
                    }, {
                        html: Lang.stary.capitalise() + "/",
                        bodyStyle: 'font: bold 12px arial, tahoma, verdana, sans-serif; padding-left: 15px;background-color: #e4e4e4;'
                    }, {
                        html: Lang.nowy.capitalise(),
                        width: '100%',
                        bodyStyle: 'color:#dc5b00;font:normal 12px arial, tahoma, verdana, sans-serif;background-color: #e4e4e4;cursor: pointer;',
                        listeners: {
                            render: function (c) {
                                c.getEl().on('click', function () {
                                    if (AppOPERATOR.id == Const.OPERATOR_SERWIS_ID1) {
                                        window.location.href = '/?newui=true';
                                    }
                                });
                            }
                        }
                    }]
                }, {
                    xtype: 'box',
                    itemId: 'is-update-panel',
                    hidden: true,
                    html: Lang.aktualizacja_dostepna.toUpperCase(),
                    style: 'text-align: center; color: #dc5b00;font: bold 12px arial, tahoma, verdana, sans-serif;background-color: #e4e4e4; padding-top: 10px;'
                }, {
                    layout: 'hbox',
                    itemId: 'newest-version-panel',
                    hidden: true,
                    style: 'padding: 10px 0 0 70px;background-color: #e4e4e4;',
                    items: [{
                        html: Lang.najnowsza_wersja + ":",
                        bodyStyle: 'color:#dc5b00;font: bold 12px arial, tahoma, verdana, sans-serif;background-color: #e4e4e4;'
                    }, {
                        itemId: 'newest-version-box',
                        html: '',
                        width: '100%',
                        bodyStyle: 'font: bold 12px arial, tahoma, verdana, sans-serif; padding-left: 15px;background-color: #e4e4e4;'
                    }]
                }, Ext.create('Ext.panel.Panel', {
                    id: this.cid + 'btnpanel',
                    style: 'margin-top: 18px;',
                    cls: 'about-btnpanel',
                    layout: {
                        type: 'hbox',
                        align: 'stretch',
                        pack: 'center'
                    },
                    items: [{
                        xtype: 'button',
                        id: this.cid + "okb",
                        text: Lang.ok.capitalise(),
                        height: 20,
                        scale: 'small',
                        style: 'margin-right: 10px',
                        width: 65,
                        listeners: {
                            scope: this,
                            click: function () {
                                this.closeOp();
                            }
                        }
                    }, {
                        xtype: 'button',
                        id: this.cid + "pobierzb",
                        text: Lang.pobierz.capitalise(),
                        height: 20,
                        scale: 'small',
                        style: 'margin-right: 10px',
                        hidden: WindowExdMobileDEVICEV,
                        listeners: {
                            scope: this,
                            click: function () {
                                var w = Ext.create('WindowPobierz');
                                w.showW();
                            }
                        }
                    }, {
                        xtype: 'button',
                        id: this.cid + "licencjab",
                        text: Lang.licencja.capitalise(),
                        height: 20,
                        scale: 'small',
                        listeners: {
                            scope: this,
                            click: function () {
                                var w = Ext.create('WActivate');
                                w.showW();
                            }
                        }
                    }]
                })]
            }]
        }];
        this.callParent(arguments);
    },
    showW: function () {
        this.show();
        this.center();
        this.setKeyMap({
            'ESC': {
                scope: this,
                handler: this.closeOp
            }
        });
        if (Const.ENABLECUSTOMVENDOR) {
            Ext.get(this.cid + "arccan").hide();
        }
        Ext.get(this.cid + "arccan").on("click", function () {
            window.location = "http://www.arccan.eu";
        }, this);
        Ext.get(this.cid + "arccan").on("mouseover", function (e, t, o) {
            Ext.get(t).applyStyles("border:1px solid #dc5b00;padding:1px;position:absolute;top:61px;left:18px");
        }, this);
        Ext.get(this.cid + "arccan").on("mouseout", function (e, t, o) {
            Ext.get(t).applyStyles("border:0px solid #dc5b00;padding:0px;position:absolute;top:63px;left:20px");
        }, this);
        if (!validPrivilegesOperatorComplex("access.manage.activation")) {
            Ext.get(this.cid + "okb").applyStyles({
                left: "105px"
            });
            if (!WindowExdMobileDEVICEV)
                Ext.get(this.cid + "pobierzb").applyStyles({
                    left: "185px"
                });
            Ext.get(this.cid + "licencjab").applyStyles({
                display: "none"
            });
        }
        if (!Const.CLOUDFLAG) {
            this.mask(Lang.ladowanie);
            performAjaxLPromise('rest/activationmgr/getObjectData').then(data => {
                if (data && data.productKey) {
                    this.down('#productKey-panel').setHidden(false);
                    this.down('#productKey-box').setHtml(data.productKey);
                    this.addHeight(24);
                }
            }).catch(err => {
                Ext.MessageBox.alert(Lang.error, err);
            });
            performAjaxLPromise('rest/maintenanceinfo/getUpdateInfo').then(data => {
                if (data) {
                    let heightSum = 0;
                    if (data.actualizationAvailable) {
                        heightSum += 45;
                        this.down('#is-update-panel').setHidden(false);
                        this.down('#newest-version-panel').setHidden(false);
                        this.down('#newest-version-box').setHtml(data.latestAvailableActualizationVersion);
                    }
                    if (data.opiekun) {
                        this.down('#opiekun-panel').setHidden(false);
                        this.down('#opiekun-box').setHtml(`${data.opiekun.name} ${data.opiekun.surname}<br>${data.opiekun.firma}<br>
                            ${data.opiekun.email}<br>${data.opiekun.telefon}`);
                        heightSum += 68;
                    }
                    if (data.maintenanceTo) {
                        this.down('#maintenanceTo-panel').setHidden(false);
                        this.down('#maintenanceTo-box').setHtml(data.maintenanceTo);
                    }
                    this.addHeight(heightSum);
                }
            }).catch(err => {
                Ext.MessageBox.alert(Lang.error, err);
            }).finally(() => {
                this.unmask();
            });
        }
        if (!AppActivated) {
            this.addHeight(44);
        }
    },
    closeOp: function () {
        this.close();
    },
    addHeight: function (height) {
        this.setHeight(this.getHeight() + height);
        this.center();
    }
});
